import { render } from "./NotFound.vue?vue&type=template&id=40e19eb0&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=40e19eb0&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e19eb0"]])

export default __exports__